'use client'

import { useEffect } from 'react'
import { Text } from '@vinted/web-ui'

import { ViewLandingPageEvent } from '_libs/common/event-tracker/events'
import { Screen } from 'constants/tracking/screens'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import IntroductionSection from './components/IntroductionSection'
import VideoSection from './components/VideoSection'
import ValuePropositionSection from './components/ValuePropositionSection'
import HowItWorksSection from './components/HowItWorksSection'
import ClosingSection from './components/ClosingSection'
import ReviewsSection from './components/ReviewsSection'

const ItemVerificationLandingPage = () => {
  const { track } = useTracking()
  const translate = useTranslate()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: Screen.ItemVerification,
        path: '/item_verification',
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  return (
    <main className="item-verification">
      <IntroductionSection />
      <VideoSection />
      <ValuePropositionSection />
      <HowItWorksSection />
      <ReviewsSection />
      <ClosingSection />
      <div className="item-verification__note">
        <Text as="h4" type={Text.Type.Caption}>
          {translate('item_verification.note')}
        </Text>
      </div>
    </main>
  )
}

export default ItemVerificationLandingPage
